<img
  src="../../../../assets/icons/add-base.svg"
  alt="no icon"
  class="icon"
  [ngClass]="{ disabled: !canUpdate }"
  (click)="addJonquillo()"
/>
